import React from 'react';
import { useRouter } from 'next/router';
import setResponseHeaders from '@buzzfeed/headers';
import pixelGridGif from '../components/CreationLander/Tabs/pixel-grid.gif';
import Button from '../components/Button';
import downloadOnAppStore from '../public/static/images/downloadOnAppStore.svg';
import styles from './index.module.scss';

const images = [
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/coBEEkke9t.png?output-format=jpg&output-quality=90&resize=800%3A',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/5wkX5CFPA.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/kKRup_HjZ.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/7iXvvGASN.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ner2MJsj4.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/N2_GET7Yx.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/iGBLrpheh.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/KmPpG6dFw.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/juPWtHUX4.png?output-format=jpg&output-quality=90&resize=800%3A*',
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/DZCCkqxI9.png?output-format=jpg&output-quality=90&resize=800%3A*',
];

const Page = () => {
  const router = useRouter();

  const handleCreateClick = () => {
    router.push('/discover');
  };

  const handleDownloadClick = () => {
    router.push('/signup');
  };

  return (
    <div className={styles.content}>
      <div className={styles.textSection}>
        <div className={styles.textWrapper}>
          <div className={styles.text}>Stop scrolling, start creating</div>
          <div className={styles.text}>
            Give your group chat something to talk about
          </div>
          <div className={styles.text}>
            Take it for a spin, then download the app to unlock unlimited
            access.
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            onClick={handleCreateClick}
            className={styles.button}
            text="Explore generators"
            height={44}
            backgroundColor="black"
            backgroundImage={`url(${pixelGridGif})`}
            shadowColor="black"
            fontSize="20px"
            borderColor="white"
            borderWidth="1"
            letterSpacing="0.5px"
          />
          <button className={styles.download}>
            <img
              src={downloadOnAppStore}
              alt="Download on the App Store"
              onClick={handleDownloadClick}
            />
          </button>
        </div>
      </div>
      <div className={styles.imageSection}>
        <div className={styles.imgMarquee1}>
          {images.slice(0, 5).map((image, index) => (
            <img key={image} src={image} alt={`Island creation ${index + 1}`} />
          ))}
          {images.slice(0, 5).map((image, index) => (
            <img
              key={`duplicate-${image}`}
              src={image}
              alt={`Island creation ${index + 1}`}
            />
          ))}
        </div>
        <div className={styles.imgMarquee2}>
          {images.slice(5, 10).map((image, index) => (
            <img key={image} src={image} alt={`Island creation ${index + 6}`} />
          ))}
          {images.slice(5, 10).map((image, index) => (
            <img
              key={`duplicate-${image}`}
              src={image}
              alt={`Island creation ${index + 6}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Page;

export async function getServerSideProps({ req, res }) {
  try {
    setResponseHeaders({
      req,
      res,
      maxAge: 86400,
      contentIDs: [],
    });

    return {
      props: {
        tracking: {
          context_page_id: 'home',
          context_page_type: 'utility',
        },
      },
    };
  } catch (error) {
    if (error.status === 404) {
      return {
        notFound: true,
      };
    }

    throw error;
  }
}
